import React from "react";

import AccountingOverview from "./AccountingOverview";
import AccountingTabs from "./AccountingTabs";
import LedgerWorkspace from "./LedgerWorkspace";
import AccountGroupWorkspace from "./AccountGroupWorkspace";

const BusinessDetailsDrawer = ({
    open,
    business,

    activeTab,
    setActiveTab,

    ledgers,
    accountGroups,

    loading,
    onClose,
}) => {
    if (!open || !business) {
        return null;
    }

    const businessName = business.business_name || business.name || "Business";

    return (
        <div className="business-drawer-overlay">
            {/* BACKDROP */}
            <div className="business-drawer-backdrop" onClick={onClose} />

            {/* DRAWER */}
            <aside className="business-drawer">
                {/* HEADER */}
                <div className="business-drawer-header">
                    <div>
                        <span className="drawer-eyebrow">BUSINESS WORKSPACE</span>

                        <h2>{businessName}</h2>

                        <p>{business.client_name}</p>
                    </div>

                    <button className="drawer-close" onClick={onClose} aria-label="Close">
                        ×
                    </button>
                </div>

                {/* OVERVIEW */}
                <AccountingOverview ledgers={ledgers} accountGroups={accountGroups} />

                {/* TABS */}
                <AccountingTabs
                    activeTab={activeTab}
                    onChange={setActiveTab}
                    ledgerCount={ledgers.length}
                    groupCount={accountGroups.length}
                />

                {/* CONTENT */}
                <div className="business-drawer-content">
                    {loading ? (
                        <div className="accounting-loading">
                            Loading accounting records...
                        </div>
                    ) : (
                        <>
                            {activeTab === "ledgers" &&
                                <LedgerWorkspace ledgers={ledgers}
                            />}

                            {activeTab === "groups" && (
                                <AccountGroupWorkspace
                                    accountGroups = { accountGroups }
                                    ledgers = { ledgers }
                                />
                            )}
                        </>
                    )}
                </div>
            </aside>
        </div>
    );
};

export default BusinessDetailsDrawer;
